import {Controller} from '@hotwired/stimulus';

const INTERACTIVE = 'a, button, input, label, select, textarea, summary, [role="button"]';

/**
 * Ligne de table entièrement cliquable (table.md › row hover), posé sur le `tbody`. Un clic sur une ligne ouvre
 * son lien (`link`), qui reste seul atteignable au clavier : le clic de ligne s'ajoute pour la souris, il ne
 * remplace rien. Ctrl, Cmd ou le bouton du milieu ouvrent un nouvel onglet ; un lien, un bouton, un champ de la
 * ligne ou un texte sélectionné gardent leur propre effet.
 */
export default class extends Controller {
  static targets = ['link'];

  open(event) {
    if (event.button > 1 || event.target.closest(INTERACTIVE) || window.getSelection().toString() !== '') {
      return;
    }

    const link = event.target.closest('tr')?.querySelector('[data-row-link-target="link"]');

    if (!link || !this.element.contains(link)) {
      return;
    }

    if (event.ctrlKey || event.metaKey || event.button === 1) {
      window.open(link.href, '_blank', 'noopener');

      return;
    }

    window.location.assign(link.href);
  }
}
